import {createSlice} from '@reduxjs/toolkit';
import saleHelper from '../../../utilities/SaleHelper';
import {getSalePricesAsync, getTechnicianTimesAsync, createSaleAsync} from './AddonsBlockAsyncThunk';

const initialState = {
  saleType: '', //tv|app|cellular|internet|triple
  flowType: '', //service|mesh|internetSpeed
  addonId: '', //'BUNDSIVB'
  isAlternativeAddon: false,
  page: '',
  errorPage: '',
  errorDescription: '',
  successType: '',
  isDisplayWhatsApp: false,
  isDisplayTermsCheckbox: false,
  isDisplayAlternativeMeshPopup: false,
  isDisplayPrimaryEmail: false,
  successPageText: '',
  internetSpeedRemarkList: [],
  termsLink: '',
  meshLink: '',
  meshUltraLink: '',
  meshStarProLink: '',
  debtPaymentLink: '',
  updatePaymentLink: '',
  infrastructureData: {},
  isDisplayMoreSpeedLink: false,
  subscriber: {},
  saleCatalog: {},
  selectedService: {},
  selectedMeshList: [],
  selectedSpeed: {},
  upgradeSpeedList: [],
  technician: {
    technicianTimes: [],
    selectedTechnicianTime: {},
    selectedTechnicianTimeDisplay: '',
    firstTechnicianTime: {},
    firstTechnicianTimeDisplay: '',
  },
  newPrimaryEmail: '',
  isWhatsAppActive: false,
  addressDetails: {},
  createSaleError: '',
  ipAddress: '',
};

const addonsBlockSlice = createSlice({
  name: 'addonsBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.saleType = action.payload.saleType;
        state.flowType = action.payload.flowType;
        state.addonId = action.payload.addonId;
        state.isDisplayWhatsApp = action.payload.isDisplayWhatsApp;
        state.isDisplayTermsCheckbox = action.payload.isDisplayTermsCheckbox;
        state.isDisplayAlternativeMeshPopup = action.payload.isDisplayAlternativeMeshPopup;
        state.isDisplayPrimaryEmail = action.payload.isDisplayPrimaryEmail;
        state.joinServiceLink = action.payload.joinServiceLink;
        state.termsLink = action.payload.termsLink;
        state.meshLink = action.payload.meshLink;
        state.meshUltraLink = action.payload.meshUltraLink;
        state.meshStarProLink = action.payload.meshStarProLink;
        state.debtPaymentLink = action.payload.debtPaymentLink;
        state.updatePaymentLink = action.payload.updatePaymentLink;
        state.successPageText = action.payload.successPageText;
        state.internetSpeedRemarkList = action.payload.internetSpeedRemarkList;
        state.page = action.payload.page;
      },
      prepare: (action) => {
        const currentBlock = action.addonsBlock;
        const saleType = saleHelper.getSaleTypeName(currentBlock.saleType.value);
        const flowType = saleHelper.getAddonsFlowTypeName(currentBlock.flowType.value);
        const addonId = currentBlock.addonId?.value;
        const isDisplayWhatsApp = !!currentBlock.isDisplayWhatsApp?.value;
        const isDisplayTermsCheckbox = !!currentBlock.isDisplayTermsCheckbox?.value;
        const isDisplayAlternativeMeshPopup = !!currentBlock.isDisplayAlternativeMeshPopup?.value;
        const isDisplayPrimaryEmail = !!currentBlock.isDisplayPrimaryEmail?.value;
        const joinServiceLink = currentBlock.joinServiceLink?.value;
        const termsLink = currentBlock.termsLink?.value;
        const meshLink = currentBlock.meshLink?.value;
        const meshUltraLink = currentBlock.meshUltraLink?.value;
        const meshStarProLink = currentBlock.meshStarProLink?.value;
        const debtPaymentLink = currentBlock.debtPaymentLink?.value;
        const updatePaymentLink = currentBlock.updatePaymentLink?.value;
        const successPageText = currentBlock.successPageText?.value;
        const internetSpeedRemarkList = currentBlock.internetSpeedRemarkList?.value;

        let page = 'subscribersPage';

        let payload = {
          saleType: saleType,
          flowType: flowType,
          addonId: addonId,
          isDisplayWhatsApp: isDisplayWhatsApp,
          isDisplayTermsCheckbox: isDisplayTermsCheckbox,
          isDisplayAlternativeMeshPopup: isDisplayAlternativeMeshPopup,
          isDisplayPrimaryEmail: isDisplayPrimaryEmail,
          joinServiceLink: joinServiceLink,
          termsLink: termsLink,
          meshLink: meshLink,
          meshUltraLink: meshUltraLink,
          meshStarProLink: meshStarProLink,
          debtPaymentLink: debtPaymentLink,
          updatePaymentLink: updatePaymentLink,
          successPageText: successPageText,
          internetSpeedRemarkList: internetSpeedRemarkList,
          page: page,
        };
        return {payload: payload};
      },
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setAddonId: (state, action) => {
      state.addonId = action.payload;
    },
    setIsAlternativeAddon: (state, action) => {
      state.isAlternativeAddon = action.payload;
    },
    setSubscriber: (state, action) => {
      state.subscriber = action.payload;
    },
    updateMesh: (state, action) => {
      let selectedMeshList = state.selectedMeshList;
      let mesh = selectedMeshList.find((x) => x.name == action.payload.name);

      if (mesh) {
        mesh.count = action.payload.count;
        state.selectedMeshList = selectedMeshList;
      } else {
        const newMesh = {name: action.payload.name, count: action.payload.count};
        state.selectedMeshList.push(newMesh);
      }
    },
    updateService: (state, action) => {
      const data = {name: action.payload, count: 1};
      state.selectedService = data;
    },
    setNewPrimaryEmail: (state, action) => {
      state.newPrimaryEmail = action.payload;
    },
    setErrorPage: (state, action) => {
      state.errorPage = action.payload.errorPage;
      state.errorDescription = action.payload.errorDescription;
      state.page = 'errorPage';
    },
    setSuccessType: (state, action) => {
      state.successType = action.payload;
      state.page = 'successPage';
    },
    setTechnicianDay: (state, action) => {
      state.technician.technicianTimes.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.isSelected = true;
          if (x.hours && x.hours.length > 0) {
            x.hours[0].isSelected = true;
          }
        } else {
          x.isSelected = false;
        }
        return x;
      });

      const selectedTechnicianTime = {
        year: action.payload.year,
        month: action.payload.month,
        day: action.payload.day,
        startDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].startDate : '',
        endDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].endDate : '',
      };
      state.technician.selectedTechnicianTime = selectedTechnicianTime;
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(
        selectedTechnicianTime.startDate,
        selectedTechnicianTime.endDate,
      );
    },
    setTechnicianSelectedTime: (state, action) => {
      state.technician.technicianTimes.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.hours.map(function (hour) {
            if (hour.startDate == action.payload.startDate) {
              hour.isSelected = true;
            } else {
              hour.isSelected = false;
            }
            return hour;
          });
        }
        return x;
      });
      state.technician.selectedTechnicianTime = action.payload;
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(action.payload.startDate, action.payload.endDate);
    },
    setUpgradeSpeedList: (state, action) => {
      state.upgradeSpeedList = action.payload;
    },
    setSelectedSpeed: (state, action) => {
      const data = {name: action.payload, count: 1};
      state.selectedSpeed = data;
    },
    setIsWhatsAppActive: (state, action) => {
      state.isWhatsAppActive = action.payload;
    },
    setInfrastructureData: (state, action) => {
      state.infrastructureData = action.payload;
    },
    setIsDisplayMoreSpeedLink: (state, action) => {
      state.isDisplayMoreSpeedLink = action.payload;
    },
    setAddressDetails: (state, action) => {
      state.addressDetails = action.payload;
    },
    setCreateSaleError: (state, action) => {
      state.createSaleError = action.payload;
    },
    reportDWH: (state, action) => {},
  },
  extraReducers: {
    [getSalePricesAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.saleCatalog = action.payload.saleCatalog;
    },
    [getTechnicianTimesAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      let technicianTimes = getCustomTechnicianTimes(action.payload);
      if (technicianTimes?.length > 0) {
        technicianTimes[0].isSelected = true;
        if (technicianTimes[0].hours?.length > 0) {
          technicianTimes[0].hours[0].isSelected = true;
        }
      }
      state.technician.technicianTimes = technicianTimes;

      const firstTechnicianTime = {
        startDate: technicianTimes[0].hours[0].startDate,
        endDate: technicianTimes[0].hours[0].endDate,
      };

      state.technician.firstTechnicianTime = firstTechnicianTime;
      state.technician.selectedTechnicianTime = firstTechnicianTime;
      state.technician.firstTechnicianTimeDisplay = getTechnicianTimeDisplay(
        technicianTimes[0].hours[0].startDate,
        technicianTimes[0].hours[0].endDate,
      );
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(
        technicianTimes[0].hours[0].startDate,
        technicianTimes[0].hours[0].endDate,
      );
    },
    [createSaleAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      if (action.payload.additionalResultValue?.IPADDRESS) {
        state.ipAddress = action.payload.additionalResultValue?.IPADDRESS;
      }
    },
  },
});

function getCustomTechnicianTimes(technicianTimesList) {
  if (!technicianTimesList) {
    return;
  }

  const groups = technicianTimesList.reduce((groups, item) => {
    const date = item.start.split('T')[0];
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      hours: groups[date],
    };
  });

  let technicianTimes = [];

  groupArrays.forEach((item) => {
    let currentDate = new Date(item.date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let monthName = getMonthName(currentDate.getMonth());
    let day = currentDate.getDate();
    let dayOfWeek = getDayOfWeek(currentDate.getDay());
    let hours = [];

    item.hours.forEach((hour) => {
      let startDate = new Date(hour.start);
      let endDate = new Date(hour.end);

      const hourItem = {
        startDate: hour.start,
        endDate: hour.end,
        start: ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2),
        end: ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2),
        isSelected: false,
      };

      hours.push(hourItem);
    });

    let technicianTime = {
      year: year,
      month: month,
      monthName: monthName,
      day: day,
      dayOfWeek: dayOfWeek,
      hours: hours,
      isSelected: false,
    };

    technicianTimes.push(technicianTime);
  });

  return technicianTimes;
}

function getMonthName(month) {
  const monthNames = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
  return monthNames[month];
}

function getDayOfWeek(dayOfWeek) {
  const weekDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  return weekDays[dayOfWeek];
}

function getTechnicianTimeDisplay(start, end) {
  let startDate = new Date(start);
  let endDate = new Date(end);

  const dayOfWeek = getDayOfWeek(startDate.getDay());
  const dateToDisplay = formatDate(startDate);

  const startHour = ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2);
  const endHour = ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2);

  let selectedTechnicianTimeDisplay = `${dayOfWeek} ${dateToDisplay} בין ${startHour}-${endHour}`;
  return selectedTechnicianTimeDisplay;
}

function formatDate(date) {
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const dateToDisplay = dd + '.' + mm + '.' + yyyy;
  return dateToDisplay;
}

export const {
  resetBlock,
  initBlock,
  goToPage,
  setAddonId,
  setIsAlternativeAddon,
  setSubscriber,
  updateMesh,
  updateService,
  setNewPrimaryEmail,
  setErrorPage,
  setSuccessType,
  setTechnicianDay,
  setTechnicianSelectedTime,
  setUpgradeSpeedList,
  setSelectedSpeed,
  setIsWhatsAppActive,
  setInfrastructureData,
  setIsDisplayMoreSpeedLink,
  setAddressDetails,
  setCreateSaleError,
  reportDWH,
} = addonsBlockSlice.actions;

export default addonsBlockSlice.reducer;
